import React from "react"
import Footer from "../Components/Outlets/Footer"
import Nav from "../Components/Outlets/Nav"
import banner from "../Assets/site3.jpg"
import bannerTwo from "../Assets/site1.jpg"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"

const fadeUp = {
	hidden: { opacity: 0, y: 28 },
	visible: { opacity: 1, y: 0 },
}

const stats = [
	{ value: "+1 & +2", label: "Integrated academics" },
	{ value: "5+", label: "Career pathways" },
	{ value: "100%", label: "Girls-focused campus" },
	{ value: "360", label: "Student development" },
]

const focusAreas = [
	{
		icon: "ri-graduation-cap-line",
		title: "Academic Excellence",
		text: "Strong senior secondary learning with Science and Commerce options designed for board exam confidence.",
	},
	{
		icon: "ri-book-open-line",
		title: "Entrance Preparation",
		text: "Integrated coaching for NEET, JEE, KEAM, CUET, and other national-level entrance pathways.",
	},
	{
		icon: "ri-user-star-line",
		title: "Leadership Growth",
		text: "Mentoring, communication, public speaking, and life skills that help students lead with clarity.",
	},
]

const values = ["Excellence", "Confidence", "Integrity", "Empowerment", "Global Mindset"]

const programs = [
	"Integrated +1 & +2",
	"NEET / JEE Coaching",
	"CA Foundation",
	"AI & Future Skills",
	"Global University Pathways",
]

const AboutPage = () => {
	return (
		<div className="about-page-shell">
			<Nav />

			<section className="inner-hero about-hero">
				<div className="container-main">
					<motion.div
						className="inner-hero-content"
						initial={{ opacity: 0, y: 35 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.75 }}
					>
						<span className="inner-eyebrow">About Le Fille</span>
						<h1 className="inner-hero-title montserrat">A global career school for young women</h1>
						<p className="inner-hero-copy">
							Le Fille Global School blends senior secondary academics, entrance coaching, career pathways,
							and personal mentoring in a safe, ambitious environment created exclusively for girls.
						</p>
						<div className="inner-hero-actions">
							<Link to="/acadamics" className="hero-primary-btn">
								Explore Programs <i className="ri-arrow-right-line"></i>
							</Link>
							<Link to="/admission" className="hero-secondary-btn">
								Start Admission
							</Link>
						</div>
					</motion.div>
				</div>
			</section>

			<main className="about-redesign">
				<section className="about-story-section">
					<div className="container-main">
						<div className="row align-items-center g-5">
							<div className="col-lg-6">
								<motion.div
									className="about-media-grid"
									variants={fadeUp}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
									transition={{ duration: 0.7 }}
								>
									<div className="about-media-frame about-media-large">
										<img src={bannerTwo} alt="Le Fille students walking on campus" />
									</div>
									<div className="about-media-frame about-media-small">
										<img src={banner} alt="Le Fille students collaborating" />
									</div>
									<div className="about-floating-note">
										<i className="ri-shield-star-line"></i>
										<span>Safe, focused, and future-ready learning for girls</span>
									</div>
								</motion.div>
							</div>

							<div className="col-lg-6">
								<motion.div
									className="about-story-copy"
									variants={fadeUp}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
									transition={{ duration: 0.7, delay: 0.1 }}
								>
									<span className="section-eyebrow">Our Purpose</span>
									<h2 className="section-title montserrat">Built for ambition, care, and clarity</h2>
									<p className="section-copy">
										We help young women move through +1 and +2 with a clear academic plan, strong mentoring,
										and exposure to competitive entrance and professional career routes.
									</p>
									<p className="section-copy">
										Every part of the school experience is designed to build confidence: classroom learning,
										career counseling, communication, emotional wellbeing, and global outlook.
									</p>
									<div className="about-feature-list">
										<div className="about-feature-item">
											<i className="ri-check-line"></i>
											<span>Science and Commerce streams with structured support</span>
										</div>
										<div className="about-feature-item">
											<i className="ri-check-line"></i>
											<span>Entrance coaching integrated with the daily academic rhythm</span>
										</div>
										<div className="about-feature-item">
											<i className="ri-check-line"></i>
											<span>Mentorship for national and global career decisions</span>
										</div>
									</div>
								</motion.div>
							</div>
						</div>
					</div>
				</section>

				<section className="about-stat-band">
					<div className="container-main">
						<div className="row g-3">
							{stats.map((stat, index) => (
								<div className="col-lg-3 col-md-6" key={stat.label}>
									<motion.div
										className="about-stat-card"
										variants={fadeUp}
										initial="hidden"
										whileInView="visible"
										viewport={{ once: true }}
										transition={{ duration: 0.5, delay: index * 0.06 }}
									>
										<strong>{stat.value}</strong>
										<span>{stat.label}</span>
									</motion.div>
								</div>
							))}
						</div>
					</div>
				</section>

				<section className="about-focus-section">
					<div className="container-main">
						<div className="section-heading-row">
							<div>
								<span className="section-eyebrow">What Guides Us</span>
								<h2 className="section-title montserrat">Mission, vision, and daily practice</h2>
							</div>
							<p className="section-copy">
								Our goal is simple: help every student become academically capable, emotionally grounded,
								and confident enough to choose a meaningful future.
							</p>
						</div>

						<div className="row g-4">
							<div className="col-lg-6">
								<motion.div
									className="about-belief-panel mission-panel"
									variants={fadeUp}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
									transition={{ duration: 0.6 }}
								>
									<i className="ri-compass-3-line"></i>
									<h3>Our Mission</h3>
									<p>
										To empower young women with excellent education, essential life skills, and the confidence
										to succeed in India and beyond.
									</p>
								</motion.div>
							</div>
							<div className="col-lg-6">
								<motion.div
									className="about-belief-panel vision-panel"
									variants={fadeUp}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
									transition={{ duration: 0.6, delay: 0.1 }}
								>
									<i className="ri-global-line"></i>
									<h3>Our Vision</h3>
									<p>
										To become a trusted girls' education destination that shapes capable, responsible,
										and globally minded women leaders.
									</p>
								</motion.div>
							</div>
						</div>

						<div className="row g-4 mt-1">
							{focusAreas.map((item, index) => (
								<div className="col-lg-4 col-md-6" key={item.title}>
									<motion.div
										className="about-focus-card"
										variants={fadeUp}
										initial="hidden"
										whileInView="visible"
										viewport={{ once: true }}
										transition={{ duration: 0.55, delay: index * 0.08 }}
									>
										<div className="about-focus-icon">
											<i className={item.icon}></i>
										</div>
										<h3>{item.title}</h3>
										<p>{item.text}</p>
									</motion.div>
								</div>
							))}
						</div>
					</div>
				</section>

				<section className="about-values-section">
					<div className="container-main">
						<div className="values-layout">
							<div className="values-copy">
								<span className="section-eyebrow">Core Values</span>
								<h2 className="section-title montserrat">The culture students feel every day</h2>
							</div>
							<div className="values-list">
								{values.map((value) => (
									<span className="value-chip" key={value}>{value}</span>
								))}
							</div>
						</div>
					</div>
				</section>

				<section className="about-programs-section">
					<div className="container-main">
						<div className="section-heading-center">
							<span className="section-eyebrow">Programs</span>
							<h2 className="section-title montserrat">Career-integrated routes under one roof</h2>
							<p className="section-copy">
								Students can combine senior secondary study with entrance coaching, professional foundations,
								future skills, and global university guidance.
							</p>
						</div>
						<div className="program-link-grid">
							{programs.map((program) => (
								<Link to="/acadamics" className="program-link-card" key={program}>
									<span>{program}</span>
									<i className="ri-arrow-right-up-line"></i>
								</Link>
							))}
						</div>
					</div>
				</section>
			</main>

			<section className="md-minimal-section">
				<div className="container-main">
					<motion.div
						className="md-minimal-inner"
						variants={fadeUp}
						initial="hidden"
						whileInView="visible"
						viewport={{ once: true }}
						transition={{ duration: 0.7 }}
					>
						<div className="md-minimal-left">
							<span className="md-minimal-label">Managing Director's Message</span>
							<h3 className="md-minimal-name montserrat">Basheer Verode House</h3>
							<p className="md-minimal-role">Managing Director</p>
							<div className="md-minimal-rule"></div>
						</div>
						<div className="md-minimal-right">
							<p className="md-minimal-lead">
								At Le Fille Global School, we believe that girls' education must open doors to confidence, independence, and meaningful futures. Our vision is to create a safe, ambitious, and caring learning environment where every student discovers her strengths and learns to dream with direction.
							</p>
							<p className="md-minimal-body">
								In today's fast-changing world, learning must go beyond textbooks and examinations. We combine senior secondary academics with entrance preparation, career guidance, communication skills, leadership training, and global exposure so that our students can make informed choices with courage and clarity.
							</p>
							<p className="md-minimal-body">
								Our commitment is to shape young women who are academically strong, emotionally grounded, socially responsible, and ready for opportunities in India and beyond. With the support of dedicated mentors, modern learning practices, and a values-based campus culture, Le Fille Global School stands as a place where every girl is encouraged to rise, lead, and succeed.
							</p>
						</div>
					</motion.div>
				</div>
			</section>

			<Footer />
		</div>
	)
}

export default AboutPage
